'use client'

import { Spinner } from '@rewardops/ui'

import { useFilteredItems } from '~/components/hooks/use-filtered-items'
import { PaginationInput } from '~/components/input/pagination-input'
import ItemPagination from '~/components/items-list/items-paginated'
import { MobileTopFilters } from '~/components/maple/mobile-top-filters'
import ScrollToTopButton from '~/components/maple/scroll-to-top-button'
import { ProductsSearchProps } from './products-search'

const MobileProductsSearch = ({
  isFiltersLoading,
  brandsFilterOptions,
  categoriesFilterOptions,
  setItemSearchState,
}: ProductsSearchProps) => {
  const {
    loading: isItemsLoading,
    error,
    items,
    totalItems,
    itemsPerPage,
  } = useFilteredItems({ setItemSearchState })

  return (
    <div>
      <div className="flex-1">
        {!isFiltersLoading || !isItemsLoading ? (
          totalItems && totalItems > 0 ? (
            <MobileTopFilters
              brandsOptions={brandsFilterOptions}
              categoriesOptions={categoriesFilterOptions}
            />
          ) : null
        ) : (
          <Spinner className="container mx-auto mt-4" />
        )}

        <div className="flex-1 py-2">
          <ItemPagination
            items={items}
            itemsPerPage={itemsPerPage}
            error={error}
            loading={isItemsLoading}
          />
          <PaginationInput className="py-5" totalNumberOfItems={totalItems} />
        </div>
        <ScrollToTopButton />
      </div>
    </div>
  )
}

export default MobileProductsSearch
